export default __webpack_public_path__ + "static/media/timer2.ee93f595.png";